if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor () {
      super()

      this.form = this.querySelector('form')
      this.form.querySelector('[name=id]').disabled = false
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      this.submitButton = this.querySelector('[type="submit"]')
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')
      this.additonalProducts = new Set()
      window.addEventListener('product-crosssell-change', this.updateProductCrosssell.bind(this))
      window.addEventListener('product-form:loading', () => { this.loading = true })
      window.addEventListener('product-form:loaded', () => { this.loading = false })
    }

    updateProductCrosssell (e) {
      const selectedProducts = e.detail.selectedProducts
      this.additonalProducts = new Set(selectedProducts)
    }

    onSubmitHandler (evt) {
      evt.preventDefault()
      const formEl = evt.target
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      const isMainProductForm = formEl.querySelector('button[id*="ProductSubmitButton-template"]')

      this.handleErrorMessage()
      this.loading = true

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)
      if (isMainProductForm) {
        const additionalProductIds = this.getAdditionalProducts()
        additionalProductIds.forEach((productId, index) => {
          formData.append(`items[${index + 1}][id]`, productId)
          formData.append(`items[${index + 1}][quantity]`, 1)
          // Adding the crosssell flag to the additional products
          formData.append(`items[${index + 1}][properties][isCrosssell]`, true)
        })
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id))
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)
            this.loading = false
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          } else if (!this.cart) {
            window.location = window.routes.cart_url
            this.loading = false
            return
          }

          this.error = false
          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) })
            }, { once: true })
            quickAddModal.hide(true)
          } else {
            this.cart.renderContents(response)
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          this.loading = false
        })
    }

    getAdditionalProducts () {
      return Array.from(this.additonalProducts)
    }

    handleErrorMessage (errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      if (!this.errorMessageWrapper) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    }

    set loading (val) {
      if (val) {
        this.productInfoEl?.setAttribute('loading', 'true')
        this.setAttribute('loading', 'true')
        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
      } else {
        this.productInfoEl?.setAttribute('loading', 'false')
        this.removeAttribute('loading')
        this.submitButton.removeAttribute('aria-disabled')
        this.submitButton.classList.remove('loading')
      }
    }

    get loading () {
      return this.hasAttribute('loading')
    }

    get productInfoEl () {
      return document.querySelector('.product-info__inner')
    }

    get loadingIcon () {
      return this.querySelector('.loading-overlay__spinner')
    }
  })
}
